import React from "react"
import { get } from "lodash"
import Picture from "./Picture"
import Caption from "./Caption"

const ImageBlock = ({ block }) => {
  const images = get(
    block,
    "elements.image.value"
  )
  const caption = get(
    block,
    "elements.caption.value"
  )
  return (
    <>
      {images.map(item => {
        const image = get(
          item,
          "elements.image.value[0]"
        )
        const imageAltText = get(
          item,
          "elements.alt_text.value"
        )
        const id = get(
          item,
          "system.id"
        )
        return (
          <Picture
            image={image}
            alt={imageAltText}
            cropWidth={900}
            key={id}
          />
        )
      })}
      {caption && caption.replace(/(<p><br><\/p>|\n|\r)+/, "") ? <Caption text={caption} /> : null}
    </>
  )
  
}


export default ImageBlock